module.exports = __webpack_public_path__ + "static/media/ceremonie.123339d1.jpg";